import { render, staticRenderFns } from "./onlineTestBasicDetails.html?vue&type=template&id=3091d3b4&scoped=true&external"
import script from "./onlineTestBasicDetails.vue?vue&type=script&lang=js"
export * from "./onlineTestBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./onlineTestBasicDetails.css?vue&type=style&index=0&id=3091d3b4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3091d3b4",
  null
  
)

export default component.exports